import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from 'js/App';
import store from 'js/store/ConfigureStore';
import { Provider } from 'react-redux';
import { BASE_URL } from 'js/constants/App';

// actions
import { startBootstrap } from 'js/store/bootstrap/Bootstrap.actions';
import { PersistGate } from 'redux-persist/integration/react';

// import pages
import ErrorPage from 'js/page/Page.error';

/**
 * React additions
 */
import '../scss/styles.scss';

import { DOM_ID } from 'js/constants/App';
import { persistStore } from 'redux-persist';

const doRender = (Component = App, el) => {
  const persistor = persistStore(store);
  const root = createRoot(el);
  const routes = [
    {
      path: '/*',
      element: <App />,
      errorElement: <ErrorPage />,
    },
  ];
  const router = createBrowserRouter(routes, {
    basename: JW_WATCH ? BASE_URL.replace(window.location.origin, '') : '/',
  });

  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} fallbackElement={<div>FALLBACK</div>} />
      </PersistGate>
    </Provider>
  );
};

const mountApp = () => {
  const el = document.getElementById(DOM_ID);
  if (el === null) {
    console.error(`Dom node ${DOM_ID} is missing - aborting app`);
  } else {
    store.dispatch(startBootstrap());
    doRender(App, el);

    if (import.meta.hot) {
      import.meta.hot.accept();
    }
  }
};

if (window.cordova) {
  document.addEventListener('deviceready', mountApp, false);
} else {
  window.addEventListener('load', mountApp);
}
